export enum PersonTypeEnum {
  PERSON = 'person',
  COMPANY = 'company',
  PERSON_COMPANY = 'personCompany',
}
